module.exports = __webpack_public_path__ + "static/media/connectalphabates.b22bd318.png";